import { Autocomplete, TextField } from '@mui/material';
import { ReactNode, forwardRef, useState } from 'react';
import { FieldError } from 'react-hook-form';
import { useLocales } from 'src/locales';

interface Props {
  emails: string[];
  setEmails: (emails: string[]) => void;
  helperText?: ReactNode;
  placeholder?: string;
  error?: FieldError | boolean;
}

export const EmailInput = forwardRef<HTMLDivElement, Props>(
  ({ emails = [], setEmails, helperText, error, ...other }, ref) => {
    const { translate } = useLocales();

    const [inputValue, setInputValue] = useState('');

    const processEmails = (value: string) => {
      if (!value.trim()) return;
      const newEmails = value.split(',').map((email) => email.trim());
      const emailsList = Array.from(new Set([...emails, ...newEmails]));
      setEmails(emailsList);
      setInputValue('');
    };

    return (
      <Autocomplete
        ref={ref}
        multiple
        freeSolo
        options={emails}
        {...other}
        size="small"
        fullWidth
        sx={{
          '& textarea': {
            maxHeight: '100px',
          },
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            //override default MUI behavior
            (event as any).defaultMuiPrevented = true;
            event.preventDefault();
            processEmails(inputValue);
          }
        }}
        onBlur={() => processEmails(inputValue)}
        renderInput={(params) => (
          <TextField
            label={translate('shared.labels.emails')}
            error={!!error}
            helperText={
              helperText ||
              translate('shared.workspace.type_emails_separated_by_commas')
            }
            {...params}
          />
        )}
        inputMode="email"
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      />
    );
  },
);
